var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{staticStyle:{"margin-left":"2px","margin-top":"12px","max-width":"67px","max-height":"42px"},attrs:{"src":require('../../assets/img/kp.jpg'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }